"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.uploadFileToWritableUrl = exports.parseJsonWebToken = exports.buildFilteredEndpoint = exports.buildQueryParams = void 0;
var js_logger_1 = __importDefault(require("js-logger"));
var base_64_1 = __importDefault(require("base-64"));
var VALID_TYPES = new Set(["string", "number", "boolean"]);
function getStringVersionOfValue(obj, key) {
    var value = obj[key];
    if (VALID_TYPES.has(typeof value)) {
        return String(value);
    }
    if (Array.isArray(value)) {
        return value
            .filter(function (v) { return VALID_TYPES.has(typeof v); })
            .map(String)
            .filter(function (v) { return v; })
            .join(",");
    }
    return false;
}
function buildQueryParams(paramsObject, omitFields) {
    if (!paramsObject) {
        return "";
    }
    paramsObject = __assign({}, paramsObject);
    omitFields = omitFields || [];
    var params = [];
    for (var _i = 0, _a = Object.keys(paramsObject); _i < _a.length; _i++) {
        var key = _a[_i];
        if (omitFields.indexOf(key) >= 0) {
            continue;
        }
        var value = getStringVersionOfValue(paramsObject, key);
        if (value) {
            params.push(encodeURIComponent(key) + "=" + encodeURIComponent(value));
        }
    }
    return params.length ? "?" + params.join("&") : "";
}
exports.buildQueryParams = buildQueryParams;
function buildFilteredEndpoint(baseEndpoint, filterParams) {
    return baseEndpoint + buildQueryParams(filterParams);
}
exports.buildFilteredEndpoint = buildFilteredEndpoint;
function parseJsonWebToken(token) {
    if (!token) {
        js_logger_1.default.warn("parseJsonWebToken: no token");
        return;
    }
    var parts = token.split(".");
    if (parts.length != 3) {
        js_logger_1.default.warn("parseJsonWebToken: not 3 parts");
        return;
    }
    try {
        return JSON.parse(base_64_1.default.decode(parts[1]));
    }
    catch (error) {
        js_logger_1.default.error(error);
    }
    return;
}
exports.parseJsonWebToken = parseJsonWebToken;
function uploadFileToWritableUrl(_a) {
    var file = _a.file, writableUrl = _a.writableUrl;
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_b) {
            return [2, fetch(writableUrl, {
                    method: "PUT",
                    headers: {
                        "Content-Type": file.type,
                    },
                    body: file,
                })];
        });
    });
}
exports.uploadFileToWritableUrl = uploadFileToWritableUrl;
//# sourceMappingURL=utils.js.map